import React, { FC } from 'react';
import CustomModal from 'components/custom-modal/CustomModal';
import { VoidFn } from 'types/baseTypes';
import CustomerAddCOFContent from './CustomerAddCOFContent';
import { AddressField } from '../../invoices/invoices.model';
import { useAppSelector } from 'hooks';
import { selectCurrentTeam } from 'containers/app/appSlice';

interface CustomerAddCOFModalProps {
  isOpen: boolean;
  onClose: VoidFn;
  cardData: {
    name: string;
    email: string;
    customerId: string;
    billingAddress?: AddressField;
    id?: string;
  };
  successCallback: VoidFn;
}

const CustomerAddCOFModal: FC<CustomerAddCOFModalProps> = ({ isOpen, onClose, cardData, successCallback }) => {
  const currentTeam = useAppSelector(selectCurrentTeam);
  if (!isOpen) return null;

  return (
    <CustomModal
      open={isOpen}
      closeModal={onClose}
      className="max-h-[90vh] max-w-[90%] md:w-[457px] md:min-w-[457px]"
      overlayClassName="bg-[#00132480]"
      enableOutsideClick={false}>
      <CustomerAddCOFContent
        handleClose={onClose}
        isWebView={false}
        customerId={cardData.customerId}
        teamId={currentTeam?.id?.toString()}
        customerName={cardData.name}
        customerEmail={cardData.email}
        customerBillingAddress={cardData.billingAddress}
        cardId={cardData?.id}
        successCallback={successCallback}
      />
    </CustomModal>
  );
};

export default CustomerAddCOFModal;
